const _excluded = ["subRows"];function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
import { get, uniqBy } from 'lodash';


import { t } from "../../../../../I18N";



import { getPropertyNameFromExtractPair, getTemplateFromExtractPair } from "./sidepanelFunctions";

const generateChildrenRows = (_suggestion) => {
  const suggestion = _objectSpread(_objectSpread({}, _suggestion), {}, { isChild: false });

  const currentValues = [
  ...(Array.isArray(suggestion.currentValue) ? suggestion.currentValue : [])];


  const suggestedValues = [
  ...(Array.isArray(suggestion.suggestedValue) ? suggestion.suggestedValue : [])];


  suggestion.subRows = [];

  const { subRows } = suggestion,suggestionWithoutChildren = _objectWithoutProperties(suggestion, _excluded);
  suggestedValues.forEach((suggestedValue) => {var _suggestion$subRows;
    const suggestedValueId = get(suggestedValue, 'id') || suggestedValue;
    const valuePresent = currentValues.find(
      (v) => v === suggestedValue || v === get(suggestedValue, 'id')
    );
    if (valuePresent) {
      currentValues.splice(currentValues.indexOf(valuePresent), 1);
    }

    (_suggestion$subRows = suggestion.subRows) === null || _suggestion$subRows === void 0 ? void 0 : _suggestion$subRows.push(_objectSpread(_objectSpread({},
    suggestionWithoutChildren), {}, {
      suggestedValue,
      currentValue: valuePresent || '',
      propertyName: suggestion.propertyName,
      disableRowSelection: true,
      isChild: true,
      entityTitle: '',
      rowId: `${suggestion.rowId}-${suggestedValueId}` })
    );
  });

  currentValues.forEach((currentValue) => {var _suggestion$subRows2;
    (_suggestion$subRows2 = suggestion.subRows) === null || _suggestion$subRows2 === void 0 ? void 0 : _suggestion$subRows2.push(_objectSpread(_objectSpread({},
    suggestionWithoutChildren), {}, {
      suggestedValue: '',
      currentValue,
      disableRowSelection: true,
      isChild: true,
      entityTitle: '',
      rowId: `${suggestion.rowId}-${currentValue}` })
    );
  });

  return suggestion;
};

const propertyIsInAllTemplates = (
templates,
property) =>

templates.every((template) =>
template.properties.
filter(
  (templateProperty) => templateProperty.type === 'markdown' || templateProperty.type === 'text'
).
some((templateProperty) => {
  if (templateProperty.name === property.propertyName) {
    return true;
  }
  return false;
})
);

// eslint-disable-next-line max-statements
const getAvailableSources = (
templates,
selectedTemplatesIdsAndProperties,
extractor) =>
{
  const baseOptions = [
  {
    label: t('System', 'PDF', 'PDF', false),
    value: '0'
  }];


  if (!extractor || extractor !== null && extractor !== void 0 && extractor.source.pdf) {
    baseOptions[0].defaultChecked = true;
  }

  const commonProperty = selectedTemplatesIdsAndProperties[0] ?
  getPropertyNameFromExtractPair(selectedTemplatesIdsAndProperties[0]) :
  '';
  const templateIds = selectedTemplatesIdsAndProperties.map((selected) =>
  getTemplateFromExtractPair(selected)
  );

  const templatesIncluded = templates.filter((template) =>
  templateIds.includes(template._id.toString())
  );
  let markdownProperties =
  [];

  templatesIncluded.every((template) => {var _template$properties;
    const templateMarkdownProperties = (_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.filter(
      (property) => property.type === 'markdown' || property.type === 'text'
    );

    if (!templateMarkdownProperties.length) {
      markdownProperties = [];
      return false;
    }

    markdownProperties.push(
      ...templateMarkdownProperties.map((templateMarkdownProperty) => ({
        templateId: template._id.toString(),
        propertyName: templateMarkdownProperty.name,
        propertyLabel: templateMarkdownProperty.label
      }))
    );

    return true;
  });

  const options = [
  ...baseOptions,
  {
    label: t('System', 'Title', 'Title', false),
    value: 'title',
    defaultChecked: false
  },
  ...uniqBy(markdownProperties, 'propertyName').
  filter((markdownProperty) => propertyIsInAllTemplates(templatesIncluded, markdownProperty)).
  map((markdownProperty) => ({
    label: t(
      markdownProperty.templateId,
      markdownProperty.propertyLabel,
      markdownProperty.propertyLabel,
      false
    ),
    value: markdownProperty.propertyName,
    defaultChecked: false
  }))];


  options.some((option) => {
    if (!extractor || extractor.source.pdf) {
      // intentional pass by reference
      // eslint-disable-next-line no-param-reassign
      option.defaultChecked = true;
      return true;
    }
    if (option.value === extractor.source.property) {
      // eslint-disable-next-line no-param-reassign
      option.defaultChecked = true;
      return true;
    }
    return false;
  });

  return options.filter((option) => option.value !== commonProperty);
};

const getMetadataFromProperty = (
entity,
propertyName) =>
{
  if (!propertyName) {
    return { value: '' };
  }

  if (entity !== null && entity !== void 0 && entity.metadata && entity.metadata[propertyName]) {
    const metadataEntry = entity.metadata[propertyName];
    if (metadataEntry.length) {
      const [entry] = metadataEntry;
      return entry;
    }
  }

  return { value: '' };
};

const formatAccepted = (acceptedSuggestions) =>
// eslint-disable-next-line max-statements
acceptedSuggestions.map((acceptedSuggestion) => {
  let addedValues;
  let removedValues;

  if (acceptedSuggestion.isChild) {
    if (acceptedSuggestion.suggestedValue) {
      const { suggestedValue } = acceptedSuggestion;
      if (
      typeof suggestedValue === 'object' &&
      suggestedValue !== null &&
      'id' in suggestedValue)
      {
        addedValues = [suggestedValue.id];
      } else if (typeof suggestedValue === 'string' || typeof suggestedValue === 'number') {
        addedValues = [String(suggestedValue)];
      }
    }

    if (acceptedSuggestion.currentValue) {
      const { currentValue } = acceptedSuggestion;
      if (typeof currentValue === 'object' && currentValue !== null && 'id' in currentValue) {
        removedValues = [currentValue.id];
      } else if (typeof currentValue === 'string' || typeof currentValue === 'number') {
        removedValues = [String(currentValue)];
      }
    }
  }

  return {
    _id: acceptedSuggestion._id,
    sharedId: acceptedSuggestion.sharedId,
    entityId: acceptedSuggestion.entityId,
    addedValues,
    removedValues
  };
});

export { generateChildrenRows, getAvailableSources, getMetadataFromProperty, formatAccepted };